import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCLibraryStorytellingSessionsConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Storytelling sessions conducted" />
    </Box>
  );
};
